import { render, staticRenderFns } from "./error-component.vue?vue&type=template&id=476c8cdc"
import script from "./error-component.vue?vue&type=script&lang=js"
export * from "./error-component.vue?vue&type=script&lang=js"
import style0 from "./error-component.vue?vue&type=style&index=0&id=476c8cdc&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports